import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const DisabledAzureIcon = ()=>{
    return /*#__PURE__*/ _jsxs("svg", {
        width: "33",
        height: "32",
        viewBox: "0 0 33 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("g", {
                id: "azure-1-logo 1",
                clipPath: "url(#clip0_4281_3551)",
                children: /*#__PURE__*/ _jsx("path", {
                    id: "Vector",
                    d: "M17.9835 0L8.54998 8.18062L0.5 22.6298H7.75824L17.9835 0ZM19.2384 1.91402L15.2124 13.2616L22.9319 22.9604L7.95618 25.5335H32.5L19.2384 1.91402Z",
                    fill: "#424960"
                })
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "clip0_4281_3551",
                    children: /*#__PURE__*/ _jsx("rect", {
                        width: "32",
                        height: "32",
                        fill: "white",
                        transform: "translate(0.5)"
                    })
                })
            })
        ]
    });
};
export const ActiveAzureIcon = ()=>{
    return /*#__PURE__*/ _jsxs("svg", {
        width: "33",
        height: "32",
        viewBox: "0 0 33 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("g", {
                id: "azure-1-logo 2",
                clipPath: "url(#clip0_4281_1530)",
                children: /*#__PURE__*/ _jsx("path", {
                    id: "Vector",
                    d: "M17.9835 0L8.54998 8.18062L0.5 22.6298H7.75824L17.9835 0ZM19.2384 1.91402L15.2124 13.2616L22.9319 22.9604L7.95618 25.5335H32.5L19.2384 1.91402Z",
                    fill: "#0072C6"
                })
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "clip0_4281_1530",
                    children: /*#__PURE__*/ _jsx("rect", {
                        width: "32",
                        height: "32",
                        fill: "white",
                        transform: "translate(0.5)"
                    })
                })
            })
        ]
    });
};
export const AzureIconXS = ()=>{
    return /*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: [
            /*#__PURE__*/ _jsxs("g", {
                opacity: "0.5",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "M8.3346 1.63599H14.8441L8.0866 21.6577C8.01715 21.8635 7.88492 22.0423 7.70854 22.1689C7.53215 22.2956 7.32049 22.3637 7.10335 22.3637H2.03735C1.87282 22.3638 1.71066 22.3246 1.56427 22.2495C1.41789 22.1744 1.29148 22.0656 1.19552 21.9319C1.09955 21.7983 1.03679 21.6437 1.01241 21.481C0.988038 21.3183 1.00276 21.1521 1.05535 20.9962L7.3511 2.34199C7.42052 2.13617 7.55277 1.95731 7.7292 1.83061C7.90564 1.70391 8.11738 1.636 8.3346 1.63599Z",
                        fill: "url(#paint0_linear_104_14598)"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M17.7939 15.0652H7.47144C7.37547 15.0651 7.2817 15.0939 7.20233 15.1478C7.12297 15.2018 7.06169 15.2784 7.02648 15.3677C6.99127 15.4569 6.98376 15.5547 7.00494 15.6483C7.02611 15.7419 7.07499 15.827 7.14519 15.8924L13.7782 22.0834C13.9713 22.2636 14.2256 22.3637 14.4897 22.3637H20.3347L17.7939 15.0652Z",
                        fill: "#0078D4"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M8.33474 1.63599C8.11515 1.63515 7.90105 1.70454 7.7237 1.83403C7.54635 1.96352 7.41506 2.14633 7.34899 2.35574L1.06324 20.9792C1.00711 21.1357 0.989486 21.3034 1.01186 21.4681C1.03424 21.6328 1.09596 21.7897 1.1918 21.9255C1.28763 22.0613 1.41477 22.172 1.56245 22.2483C1.71014 22.3246 1.87402 22.3642 2.04024 22.3637H7.23699C7.43054 22.3292 7.61144 22.2438 7.76121 22.1164C7.91099 21.9891 8.02427 21.8242 8.08949 21.6387L9.34299 17.9445L13.8205 22.1207C14.0081 22.2759 14.2435 22.3618 14.487 22.3637H20.3102L17.7562 15.0652L10.311 15.067L14.8677 1.63599H8.33474Z",
                        fill: "url(#paint1_linear_104_14598)"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M16.6489 2.34099C16.5795 2.1355 16.4475 1.95693 16.2713 1.83046C16.0951 1.70398 15.8837 1.63596 15.6669 1.63599H8.41211C8.62897 1.636 8.84037 1.70403 9.01653 1.8305C9.19269 1.95697 9.32475 2.13552 9.39411 2.34099L15.6901 20.996C15.7427 21.1519 15.7575 21.3181 15.7331 21.4809C15.7088 21.6436 15.646 21.7982 15.5501 21.9319C15.4541 22.0656 15.3277 22.1745 15.1813 22.2497C15.0349 22.3248 14.8727 22.364 14.7081 22.364H21.9631C22.1277 22.3639 22.2898 22.3247 22.4362 22.2496C22.5826 22.1744 22.709 22.0655 22.8049 21.9318C22.9008 21.7981 22.9636 21.6435 22.9879 21.4808C23.0122 21.3181 22.9975 21.1519 22.9449 20.996L16.6489 2.34099Z",
                        fill: "url(#paint2_linear_104_14598)"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("defs", {
                children: [
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint0_linear_104_14598",
                        x1: "10.7071",
                        y1: "3.17199",
                        x2: "3.94685",
                        y2: "23.1435",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#114A8B"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#0669BC"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint1_linear_104_14598",
                        x1: "12.819",
                        y1: "12.4792",
                        x2: "11.2552",
                        y2: "13.008",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopOpacity: "0.3"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.071",
                                stopOpacity: "0.2"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.321",
                                stopOpacity: "0.1"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.623",
                                stopOpacity: "0.05"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint2_linear_104_14598",
                        x1: "11.9589",
                        y1: "2.58949",
                        x2: "19.3796",
                        y2: "22.3597",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#3CCBF4"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#2892DF"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
export function AzureIcon(param) {
    let { isDisabled } = param;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: isDisabled ? /*#__PURE__*/ _jsx(DisabledAzureIcon, {}) : /*#__PURE__*/ _jsx(ActiveAzureIcon, {})
    });
}
